import getCards from 'api/v1/transactions/getCards';
import { isAccountableBankingAuthorizationFailure } from 'components/pages/Banks/Wallet/helpers';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { BankTransactionsCacheKeys } from 'types/cacheKeys.types';
import type { Card, Connector } from 'types/transactions.types';
import useGetConnectors from './useGetConnectors';

const useGetCardsList = (
  onSuccess?: (cardsList: Card[]) => void,
): UseQueryResult<Card[]> => {
  const { data } = useGetConnectors();

  const connectors = (data || []) as Connector[];

  const failedAuthorization = connectors.some(
    isAccountableBankingAuthorizationFailure,
  );

  return useQuery([BankTransactionsCacheKeys.Cards], getCards, {
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    enabled: !failedAuthorization,
  });
};

export default useGetCardsList;
